module.exports = __webpack_public_path__ + "assets/images/mirror-04.9da91e7d4a95eb77d5bb2cb17dffdd46.svg";